var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-development__container"},[_c('div',{staticClass:"alert-development__block"},[_c('alert-circle-outline'),_c('div',{staticClass:"alert-development__message"},[_vm._v(" Coming soon!"),_c('br'),_c('br'),_vm._v(" "+_vm._s(_vm.message)+" ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }